import React, { useContext } from 'react';
import { PageContext } from '../PageContext';
import { Page } from '../types';

const PrivateGamePage: React.FC = () => {
    const pageContext = useContext(PageContext);

    return (
        <div className="space-y-4">
            <button onClick={() => pageContext?.goBack()} className="mb-2 text-emerald-600 font-semibold flex items-center">
                <i className="ph-duotone ph-arrow-left mr-1"></i> Back to Profile
            </button>
            <div className="flex justify-between items-center bg-white p-2 rounded-xl shadow-sm">
                <input
                    type="text"
                    placeholder="Create a post for this group..."
                    className="w-full border-none focus:ring-0 bg-transparent rounded-lg px-4 py-2 cursor-pointer"
                    readOnly
                    onClick={() => alert('Create a new private post!')}
                />
                <button onClick={() => pageContext?.switchPage(Page.Leaderboard, 'Leaderboard')} className="ml-2 bg-yellow-400 text-white p-2 rounded-lg">
                    <i className="ph-duotone ph-trophy text-xl"></i>
                </button>
            </div>
            <div id="private-game-feed" className="space-y-4">
                <p className="text-center text-gray-500 py-8">No posts in this game yet.</p>
            </div>
        </div>
    );
};

export default PrivateGamePage;